import { useState } from "react";

import MainButton from "~/components/common/mainButton";
import Modal from "~/components/ui/modal";
import { BookingGuestType } from "~/types/event/event.types";

import styles from "./index.module.scss";

type Props = {
  isLoading: boolean;
  guestNumber: number;
  hasBooking: boolean;
  guests?: BookingGuestType[];
};

const GuestButton = ({ isLoading, guestNumber, hasBooking, guests }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // if there are no guests, don't show the button
  if (guestNumber === 0) return null;

  return (
    <>
      <MainButton
        theme="transparent-grey"
        isLoading={isLoading}
        uiOnly={!hasBooking}
        onClick={handleOpenModal}
      >
        {guestNumber}
      </MainButton>

      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        showAnimation="fade-in"
      >
        <div className={styles.modalContainer}>
          {!guests || guests.length === 0 ? (
            <p>No guests</p>
          ) : (
            <ul>
              {guests?.map((guest) => (
                <li key={guest.id}>
                  {guest.firstname} {guest.lastname}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Modal>
    </>
  );
};

export default GuestButton;
